<div class="ig-actions"
     [class.showing]="isShowing"
     [class.hiding]="!isShowing"
     (mouseleave)="!toggleByParent && hide()"
     (mouseenter)="!toggleByParent && show()"
     data-testId="actionsContainer">
    <div #trigger class="more">
        <mat-icon>more_horiz</mat-icon>
    </div>

    <div #iconButtons class="actions">
        <ng-content></ng-content>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/row.action.buttons/actions/actions.component.html